import React from "react";
import { Container } from "react-bootstrap";
import { Icon } from "components";
import { logout } from "store/auth";
import useRouter from "util/useRouter";

const stContainer = {
  height: 56,
  //Dominos
  backgroundColor: "#006491",

  // Outros
  // backgroundColor: "rgba(3, 73, 111, 1)",

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const stIconMenu = {
  color: "#FFFFFF",
  cursor: "pointer",
  fontSize: 24,
};

const stIcons = {
  color: "#FFFFFF",
  marginLeft: 16,
  fontSize: 24,
  cursor: "pointer",
};

const TopBar = (props) => {
  const { toggleMenu } = props;
  const { history } = useRouter();

  return (
    <Container fluid style={stContainer}>
      <Icon name="menu" style={stIconMenu} onClick={toggleMenu} />

      <div>
        {/* <Icon name="help" style={stIcons} />
        <Icon name="apps" style={stIcons} />
        <Icon name="notifications" style={stIcons} /> */}
        <Icon
          name="exit_to_app"
          style={stIcons}
          onClick={() => {
            logout();
            history.push("/");
          }}
        />
      </div>
    </Container>
  );
};

export default TopBar;
